'use client'

import config from '@/config'
import { useSidebarAutoScroll } from '@/hooks'
import { useMainLayoutStore } from '@/stores/layout'
import { useViewportSize } from '@mantine/hooks'
import { PropsWithChildren, useLayoutEffect } from 'react'

type MainLayoutProviderProps = PropsWithChildren

const HEADER_HEIGHT = config.layout.HEADER_HEIGHT
const FOOTER_HEIGHT = config.layout.FOOTER_HEIGHT

const MainLayoutProvider = ({ children }: MainLayoutProviderProps) => {
  const { setSidebarHeight, setLayoutState, isShowFooter } = useMainLayoutStore()
  const { width } = useViewportSize()
  const isMobile = width < 768
  const isTablet = width >= 768 && width < 1024
  const { sidebarHeight } = useSidebarAutoScroll({
    headerHeight: HEADER_HEIGHT,
    footerHeight: isShowFooter ? FOOTER_HEIGHT : 0,
  })

  useLayoutEffect(() => {
    setSidebarHeight(sidebarHeight)
  }, [sidebarHeight])

  useLayoutEffect(() => {
    setLayoutState({ isMobile, isTablet })
  }, [isMobile, isTablet])

  return <>{children}</>
}

export default MainLayoutProvider
